import { Tab, TabProps, Tabs } from '@mui/material';
import { brandclub_colors } from '@stackline/ui';
import React, { CSSProperties, SyntheticEvent } from 'react';
import { NavLink } from 'react-router-dom';
import BeaconBasicUpgradeModal from 'src/components/AddModals/BeaconBasicUpgradeModal';
import { TabRoute } from 'src/components/CommonV2Components/GenericSideBar/types';
import { useHistory, useAppSelector } from 'src/utils/Hooks';
import { getHomeMapping } from 'src/components/Navigation/utils';
import { getAppName } from 'src/utils/app';

interface LinkTabProps {
  requiredSubscription?: boolean;
  label: string;
  route: string;
  routePrefix?: string;
  hidden?: boolean;
  containerStyle?: React.ComponentProps<'span'>['style'];
  sidebar?: boolean;
  disabled?: boolean;
  selected?: boolean; // Populated by the Material UI Tabs component
}

const LinkTab = (props: LinkTabProps) => {
  const { requiredSubscription, route, containerStyle, ...rest } = props;
  const ReduxState = useAppSelector((state) => state);
  const history = useHistory();

  // Check if the `tab` matches the route and conditionally navigate
  if (props.selected && (requiredSubscription || props.disabled)) {
    history.push(getHomeMapping('', ReduxState)[getAppName()]);
  }

  if (props.hidden) {
    return null;
  }
  return (
    <>
      <div style={{ display: 'inline-flex', alignItems: 'center', ...containerStyle }}>
        <Tab
          disableRipple
          component={requiredSubscription ? 'div' : NavLink}
          to={requiredSubscription ? undefined : route}
          onClick={requiredSubscription ? () => BeaconBasicUpgradeModal.show() : undefined}
          sx={{
            letterSpacing: 'normal',
            color: requiredSubscription ? `${brandclub_colors.gray5} !important` : undefined,
            transition: 'color 0.1s',
            '&:hover': {
              backgroundColor: requiredSubscription ? `${brandclub_colors.white} !important` : undefined,
              color: requiredSubscription ? `${brandclub_colors.darkBlue} !important` : undefined
            },
            '&.Mui-disabled': {
              color: `${brandclub_colors.gray5} !important`
            }
          }}
          {...(rest as TabProps)}
        />
      </div>
    </>
  );
};

interface AppLinkTabProps {
  tabIndex: number;
  setTabIndex: (num: number) => void;
  tabRoutes: TabRoute[];
  tabsProps: any;
  tabProps: any;
  containerStyle?: CSSProperties;
}

export const AppLinkTabs = ({
  tabIndex,
  setTabIndex,
  tabRoutes,
  tabsProps,
  tabProps,
  containerStyle
}: AppLinkTabProps) => {
  const handleTabChange = (_event: SyntheticEvent<Element>, newValue: number) => {
    setTabIndex(newValue);
  };
  const staticTabIndexRoutes = ['advertising'];
  const isStaticTab = tabRoutes.some((tabRoute) => staticTabIndexRoutes.includes(tabRoute?.tabMappedFrom));
  return (
    <Tabs
      value={isStaticTab ? 0 : tabIndex}
      TabIndicatorProps={{
        style: {
          display: 'none'
        }
      }}
      onChange={handleTabChange}
      {...tabsProps}
    >
      {tabRoutes.map((tabRoute) => {
        const isSelected = tabIndex === tabRoute.index;

        return (
          <LinkTab
            containerStyle={{
              marginLeft: isSelected ? 0 : 16,
              marginRight: isSelected ? 0 : 16,
              ...containerStyle
            }}
            key={`tab:${tabRoute.route}`}
            label={tabRoute.label}
            disabled={tabRoute.disabled}
            route={tabRoute.route}
            requiredSubscription={tabRoute.requireSubscription}
            hidden={tabRoute.hidden}
            value={tabRoute.index}
            {...tabProps}
          />
        );
      })}
    </Tabs>
  );
};
